const arrNameSingle = {};
const arrIDSingle = {
  "filterbygroup": "filter_by_group", "clearfilter": "clear_filters", "logindata": "login_data", "completiondata": "completion_data",
  "memberlaunches": "member_launches", "memberscores": "member_scores", "memberpassfail": "member_pass_fail", "loggedin": "loggedin",
  "didnotloggedin": "didnot_loggedin", "completedproduct": "completed_products", "didnotcompleteproduct": "didnot_completed_products",
  "passed80percent": "passed80_percent", "failed80percent": "failed80_percent", "topperformer": "top_performance", "bottomperformer": "bottom_performance",
  "alltime": "all_time", "past90days": "past_90_days", "past60days": "past_60_days", "past30days": "past_30_days", "past14days": "past_14_days", "past7days": "past_7_days", "custom_timeframe": "custom_timeframe",

  "myaccount": "my_account", "tutorials": "tutorials", "notifications": "notifications", "reports": "reports",
  "trainingplans": "training_plans", "certificates": "certificates", "logout": "logout",
  "email_address": "email_address", "avatar_image": "avatar_image", "firstname": "firstname", "lastname": "lastname", "middlename": "middlename",
  "membername_displayformat": "membername_displayformat", "excludefrom_reports": "exclude_from_reports", "language": "language",
  "street_address1": "street_address1", "street_address2": "street_address2", "city": "city", "state": "state", "zip": "zip",
  "timezone": "time_zone", "btnsave": "save", "btnChangePWD": "reset_password", "pool_admin": "pool_admin", "group_admin": "group_admin", "org_admin": "org_admin",

  "member_details": "member_details", "not_set": "not_set", "message": "message",
  "account_enabled": "account_enabled", "account_disabled": "account_disabled", "disable": "disable",
  "privileges": "privileges", "member_does_not_have_privileges": "member_does_not_have_privileges",
  "member_does_not_belong_groups": "member_does_not_belong_groups", "member_does_not_have_products": "member_does_not_have_products",
  "member_does_not_have_bundles": "member_does_not_have_bundles", "member_does_not_have_training_plans": "member_does_not_have_training_plans",
  "archive_user": "archive_user", "activity_timeline": "activity_timeline",
  "filter_by_date": "filter_by_date", "select_date_range": "select_date_range", "start_date": "start_date",
  "end_date": "end_date", "reset": "reset",
  "added_client_product_for_client": "added_client_product_for_client", "finished_play_of": "finished_play_of", "started_play_of": "started_play_of",
  "score": "score", "level_of_play": "level_of_play", "transcript": "transcript", "play": "play",
  "user_logged_in_portal": "user_logged_in_portal", "user_logged_out_portal": "user_logged_out_portal",
  "changed_client_activation": "changed_client_activation", "added_user_email": "added_user_email", "metrics": "metrics",
  "total_plays": "total_plays", "completions": "completions", "average_score": "average_score",
  "median_score": "median_score", "scored_80_higher": "scored_80_higher", "elearning_time": "elearning_time",
  "conversation_time": "conversation_time", "total_time": "total_time", "average_of_turns": "average_of_turns",
  "median_of_turns": "median_of_turns", "reset_password": "reset_password", "go_to_pool": "go_to_pool", "enable": "enable", "go_to_org": "go_to_org",
  "resend_verification": "resend_verification", "remove_from_pool": "remove_from_pool", "member_does_not_belong_license_pool": "member_does_not_belong_license_pool",
  "go_back": "go_back", "back": "back", "training_paln_metrics": "training_paln_metrics", "no_recorded_timeline": "no_recorded_timeline",
  "groups": "groups", "products": "products", "bundles": "bundles", "training_plans": "training_plans",
  "edit_privileges___BV_modal_title_": "edit_privileges", "privileges_for": "privileges_for", "whole_pool": "whole_pool", "specific_group": "specific_group", "no_privileges": "no_privileges",
  "no_privileges_desc": "no_privileges_desc", "data_viewer": "data_viewer", "data_viewer_desc": "data_viewer_desc", "administrator": "administrator", "administrator_desc": "administrator_desc",
  "assign_type": "assign_type", "assign_no_available": "assign_no_available", "confirm_assignment": "confirm_assignment", "assignment_results": "assignment_results", "successful_assignment": "successful_assignment",
  "user": "user", "assigned": "assigned", "result": "result", "available_groups": "available_groups", "selected_groups": "selected_groups", "select": "select",
  "filter_by_tag": "filter_by_tag", "check_all": "check_all", "clear_all": "clear_all", "done": "done", "inboxSection": "new_message", "group_name": "group_name", "group_parent": "group_parent",
  "instruction_mass_add_groups": "instruction_mass_add_groups", "add_group___BV_modal_title_": "add_group", "mass_add_group___BV_modal_title_": "mass_add_groups",
  "license_pool_tags": "license_pool_tags", "add": "add", "no_tags": "no_tags", "edit_tag___BV_modal_title_": "edit_tags", "group_tags": "group_tags", "delete": "delete", "subgroup_name": "subgroup_name",
  "table_top_level_items": "table_top_level_items", "of": "of", "table_records": "table_records",
  "remaining": "remaining", "hours": "hours", "term": "term", "go_live": "go_live", "max_expirations": "max_expirations", "trigger": "trigger", "order_fill_date": "order_fill_date", "include_expired_licenses": "include_expired_licenses",
  "hash_licenses": "hash_licenses", "product_purchase_request": "product_purchase_request", "choose_which_products": "choose_which_products", "product": "product",
  "member_name": "member_name", "license_expires": "license_expires", "assignment_date": "assignment_date", "data_viewer_menu": "data_viewer_menu",

  "choose_reporting_option": "choose_reporting_option",
  "scheduled_reports": "scheduled_reports", "transcripts_analytics": "transcripts_analytics",
  "member_report": "member_report", "group_report": "group_report", "product_report": "product_report",
  "training_plan_report": "training_plan_report", "choose_date_option": "choose_date_option", "filter_by_account_status": "filter_by_acc_status", "OnlyEnabled": "enable_account_only", "OnlyDisabled": "disable_account_only", "all_accounts": "all_accounts",
  "run_for_all_dates": "run_for_all_dates", "run_for_specified_date_range": "run_for_specified_date_range",
  "choose_report_type": "choose_report_type", "summary_data_only": "summary_data_only",
  "summary_individual_data": "summary_individual_data", "all_members": "all_members",
  "trainees_only": "trainees_only", "admins_and_data_viewers_only": "admins_and_data_viewers_only",
  "selected_individual_members": "selected_individual_members", "all_groups": "all_groups",
  "select_individual_groups": "select_individual_groups", "select_individual_tags": "select_individual_tags",
  "limited_report_to_members_with_bundle": "limited_report_to_members_with_bundle", "report_start_date": "report_start_date", "report_end_date": "report_end_date",
  "receive_report": "receive_report", "immediate_download": "immediate_download", "email": "email",
  "on_recurring_schedule": "on_recurring_schedule",
  "discontinue_scheduled_reports": "discontinue_scheduled_reports", "save_search": "save_search", "edit_search": "edit_search",
  "new_search": "new_search", "schedule": "schedule", "search_type": "search_type",
  "use_saved_search": "use_saved_search", "saved_search": "saved_search", "character": "character",
  "level_of_play": "level_of_play", "score": "score", "number_of_turns": "number_of_turns", "hide": "hide",
  "show": "show", "advance_options": "advance_options", "e_learning_time": "e_learning_time",
  "simulation_time": "simulation_time", "device": "device", "all": "all", "desktop": "desktop", "tablet": "tablet",
  "phone": "phone", "microphone_used": "microphone_used", "yes_or_no": "yes_or_no", "yes": "yes",
  "no": "no", "voiceover_gender": "voiceover_gender", "all": "all", "male": "male",
  "female": "female", "upto_play_number": "upto_play_number",
  "when_student_started": "when_student_started", "finished_transcripts_only": "finished_transcripts_only",
  "save_this_search": "save_this_search", "search_name": "search_name", "send_this_transcript": "send_this_transcript",
  "search_name": "search_name", "available_bundles": "available_bundles",
  "available": "available",
  "selected_bundles": "selected_bundles",
  "available_products": "available_products",
  "selected_products": "selected_products",
  "available_tags": "available_tags",
  "selected_tags": "selected_tags",
  "available_training_plans": "available_training_plans",
  "selected_training_plans": "selected_training_plans",
  "available_members": "available_members",
  "selected_members": "selected_members", "ctr_click": "ctr_click", "date_started": "date_started",
  "hashtag_turns": "hashtag_turns",
  "transcript_results": "transcript_results", "select_members": "select_members", "select_groups": "select_groups", "create_report_message": "create_report_message",
  "no_saved_reports": "no_saved_reports",
  "create_report": "create_report",
  "license_pool_name": "license_pool_name",
  "type": "type",
  "frequency": "frequency", "no_tag_assigned_to_group": "no_tag_assigned_to_group",
  "remove": "remove", "select_products": "select_products", "lProductsMessage": "lProductsMessage", "combined_products": "combined_products", "page": "page", "none": "none", "license_expiry": "license_expires",
  "product_details": "product_details", "user_logged_out": "user_logged_out", "lop": "lop", "client_verified_account": "client_verified_account", "are_you_sure_remove_group": "are_you_sure_remove_group",
  "confirm_removal": "confirm_removal", "this_will_assign_following": "this_will_assign_following", "to_the_following": "to_the_following", "there_are_no": "there_are_no", "available_to_assign": "available_to_assign", "users": "users", "report_firstname": "report_firstname", "report_lastname": "report_lastname", "report_center": "report_center", "report_profile_language": "report_profile_language", "transcripts_analytics_updated": "transcripts_analytics_updated", "member_report_updated": "member_report_updated", "group_report_updated": "group_report_updated", "product_report_updated": "product_report_updated", "training_plan_report_updated": "training_plan_report_updated", "member_report_coming": "member_report_coming", "group_report_coming": "group_report_coming", "product_report_coming": "product_report_coming", "message_settings": "message_settings", "message_settings_modal":"message_settings", "view_sent": "view_sent",
  "personal_email": "personal_email",
  "duplicate_messages": "duplicate_messages_to_my_personal_email_address",
  "no_messages_text": "you_have_no_messages",
  "no_sent_messages": "no_sent_messages",
  "your_account_does_not_have_access_to_training_plans": "your_account_does_not_have_access_to_training_plans",
  "your_account_does_not_have_access_to_certificates": "your_account_does_not_have_access_to_certificates",
  "inbox_title": "inbox",
  "new_message_text": "new_message",
  "date_text": "date",
  "from_text": "from",
  "subject_text": "subject",
  "notification": "notification",
  "frequency": "frequency",
  "duplicate_to_email": "duplicate_to_email",
  "email_only": "email_only",
  "61258d2e-e22c-4179-ac1b-6a0b78fca316": "member_verifies_account",
  "return_to_inbox":"return_to_inbox"


};
const arrNameMulti = {
  "filter": "filter", "copyright": "copyright", "support": "support", "contact_us": "contact_us",
  "privacy_policy": "privacy_policy", "training": "training", "about": "about",
  "training_center": "training_center", "release_date": "release_date", "organization": "organization", "administrator": "administrator",
  "edit": "edit", "privileges": "privileges", "reporting": "reporting", "data_viewer": "data_viewer", "member": "member", "subgroups": "subgroups", "group": "group",
  "transcript": "transcript", "play": "play", "select_all": "select_all", "search": "search", "go_back": "go_back", "daily": "daily", "weekly": "weekly", "monthly": "monthly",
  "quarterly": "quarterly", "semi_annually": "semi_annually", "annually": "annually", "choose_report_scope": "choose_report_scope", "select": "select", "confirm_assignment": "confirm_assignment",
  "members_2": "members_2" , "bundles": "bundles", "license_pool": "license_pool",
  "Member Verifies Account":"member_verifies_account"


};

const arrPlaceHolder = { "search": "search" };

const arrToolTip = { "export_to_excel": "export_to_excel" };

const arrNameDropDown = {
  "ddlOrg": "all_organizations", "ddlPool": "all_pools", "ddlGroup": "all_groups", "ddlSelect": "select"
};
const arrNameMenu = {
  "dashboard": "dashboard", "groups": "groups", "products": "products", "members": "members",
  "bundles": "bundles", "training_plans": "training_plans", "priviledges": "priviledges",
  "reports_analytics": "reports_analytics", "reports_analytics_new": "reports_analytics_new", "edit_menu": "edit_menu", "logs": "logs", "menu_subgroups": "menu_subgroups", "tags": "tags",
  "my_account": "my_account", "inbox": "inbox", "tutorials": "tutorials", "notifications": "notifications", "reports": "reports", "certificates": "certificates"

};

const arrDDLMemberSummary = {
  "select_action": "select_action", "assign_bundles": "assign_bundles", "assign_training_plans": "assign_training_plans", "assign_groups": "assign_groups", "assign_products": "assign_products",
  "mass_disable_accounts": "mass_disable_accounts", "mass_enable_accounts": "mass_enable_accounts", "resend_verification_emails": "resend_verification_emails",
};


const arrDDLMemberSummary_verified = {
  "filter_verified": "filter_verified", "filter_is_verified": "filter_is_verified", "filter_not_verified": "filter_not_verified"
};

const arrDDLMemberSummary_disabled = {
  "filter_disabled": "filter_disabled", "filter_is_disabled": "filter_is_disabled", "filter_not_disabled": "filter_not_disabled"
};

const arrDDLMemberSummary_privileges = {
  "filter_priviledges": "filter_priviledges", "filter_trainee": "filter_trainee", "filter_pool_admin": "filter_pool_admin", "filter_group_admin": "filter_group_admin",
  "filter_pool_data_viewer": "filter_pool_data_viewer", "filter_group_data_viewer": "filter_group_data_viewer"
};
const arrDDLMemberSummary_groups = {
  "filter_groups": "filter_groups", "filter_no_groups": "filter_no_groups"
};
const arrDDLMemberSummary_bundles = {
  "filter_bundles": "filter_bundles", "filter_no_bundles": "filter_no_bundles"
};
const arrDDLMemberSummary_products = {
  "filter_products": "filter_products", "filter_no_products": "filter_no_products"
};
const arrDDLMemberSummary_training_plans = {
  "filter_training_plans": "filter_training_plans", "filter_no_training_plans": "filter_no_training_plans"
};

const arrDDLMemberDetail_product = {
  "filter_by_product": "filter_by_product"
};

const arrDDLMemberDetail_training_plans = {
  "filter_by_training_plan": "filter_by_training_plan"
};

const arrDDLGroups_option = {
  "options": "options", "add_group": "add_group", "mass_add_groups": "mass_add_groups", "edit_tags": "edit_tags", "send_message": "send_message"
};

const arrDDLGroups_assign = {
  "assign": "assign", "assign_products": "assign_products", "assign_bundles": "assign_bundles", "assign_training_plans": "assign_training_plans"
};

const arrDDLProducts_assign = {
  "options": "options", "add_free_products": "add_free_products", "add_trial_licenses": "add_trial_licenses", "product_purchase_request": "product_purchase_request"
};

const arrDDLReporting_option = {
  "ddlSelect": "ddlSelect", "transcripts_analytics": "transcripts_analytics", "member_report": "member_report", "product_report": "product_report", "group_report": "group_report", "training_report": "training_plan_report", "usage_report": "usage_report", "completion_report": "completion_report", "feedback_survey_report": "feedback_survey_report", "training_plan_report_coming_soon": "training_plan_report_coming_soon"
};


const arrPopup = {
  "popup_sso": "popup_sso", "popup_group_deleted": "popup_group_deleted", "popup_group_added": "popup_group_added", "popup_group_name_required": "popup_group_name_required", "popup_operation_successful": "popup_operation_successful",
  "popup_tag_added": "popup_tag_added", "popup_tag_removed": "popup_tag_removed", "popup_tag_edited": "popup_tag_edited", "popup_privilege_no_permission": "popup_privilege_no_permission", "popup_admin_added": "popup_admin_added",
  "popup_unspecified_error": "popup_unspecified_error", "popup_admin_removed": "popup_admin_removed", "popup_privileges_saved": "popup_privileges_saved", "popup_profile_saved": "popup_profile_saved", "popup_report_request_sent": "popup_report_request_sent",
  "popup_report_email_request": "popup_report_email_request", "search_saved": "search_saved", "popup_refresh_started": "popup_refresh_started", "popup_refresh_running": "popup_refresh_running", "popup_refresh_error": "popup_refresh_error",
  "popup_group_unassigned": "popup_group_unassigned", "popup_bundle_unassigned": "popup_bundle_unassigned", "popup_training_plan_unassigned": "popup_training_plan_unassigned", "popup_product_unassigned": "popup_product_unassigned", "popup_report_error": "popup_report_error"
};

const arrDDLCompare = {
  "greater_than": "greater_than", "greater_than_equal_to": "greater_than_equal_to", "equal_to": "equal_to", "less_than": "less_than", "less_than_equal_to": "less_than_equal_to"
};

const arrDDLCharacter = {
  "all": "all", "active_rescue": "active_rescue", "high_risk": "high_risk", "low_risk": "low_risk", "moderate_risk": "moderate_risk"
};

const arrDDLGreaterThanEqualTo = {
  "greater_than_equal_to": "greater_than_equal_to"
};

const arrDDLLessThanEqualTo = {
  "less_than_equal_to": "less_than_equal_to"
};


const arrDDLGroupParent = {
  "parent": "parent"
};


Window.filterJSON = (filteredData, key) => {
  return filteredData.filter(entry => entry.Key === key);
}

Window.filterJSONvalue = (filteredData, value) => {
  return filteredData.filter(entry => entry.Value === value);
}


Window.NameSingle = (filteredData) => {
  Object.keys(arrNameSingle).forEach(key => {
    const obj = document.getElementsByName(key);
    if (obj) {
      const filteredValue = window.filterJSON(filteredData, arrNameSingle[key]);
      if (filteredValue.length > 0 && obj.length > 0) {
        obj[0].innerHTML = filteredValue[0].Value;
      }
    }
  });
}

Window.IDSingle = (filteredData) => {
  try {
    Object.keys(arrIDSingle).forEach(key => {
      if (key === "select") {
        //debugger;
        const abc = document.getElementById("select");
      }

      const obj = document.getElementById(key);
      if (obj) {
        const filteredValue = Window.filterJSON(filteredData, arrIDSingle[key]);
        if (filteredValue.length > 0) {
          obj.innerHTML = filteredValue[0].Value;
        }
      }
    });
  } catch (e) { }
}


Window.NameMulti = (filteredData) => {
  try {
    Object.keys(arrNameMulti).forEach(key => {
      const obj = document.getElementsByName(key);
      if (obj) {
        const filteredValue = Window.filterJSON(filteredData, arrNameMulti[key]);
        if (filteredValue.length > 0 && obj.length > 0) {
          obj.forEach(element => {
            element.innerHTML = filteredValue[0].Value;
          });
        }
      }
    });
  } catch (e) { }
}

Window.setPlaceHolder = (filteredData) => {
  try {
    Object.keys(arrPlaceHolder).forEach(key => {

      const obj = document.getElementById(key);
      if (obj) {
        const filteredValue = Window.filterJSON(filteredData, arrPlaceHolder[key]);
        if (filteredValue.length > 0) {
          obj.placeholder = filteredValue[0].Value;
        }
      }
    });
  } catch (e) { }
}


Window.setToolTip = (filteredData) => {
  try {
    Object.keys(arrToolTip).forEach(key => {

      const obj = document.getElementById(key);
      if (obj) {
        const filteredValue = Window.filterJSON(filteredData, arrToolTip[key]);
        if (filteredValue.length > 0) {
          obj.alt = filteredValue[0].Value;
          obj.title = filteredValue[0].Value;
        }
      }
    });
  } catch (e) { }
}


Window.NameDropDown = (filteredData) => {
  try {
    Object.keys(arrNameDropDown).forEach(key => {
      const obj = document.getElementsByName(key);
      if (obj) {
        const filteredValue = Window.filterJSON(filteredData, arrNameDropDown[key]);
        if (filteredValue.length > 0 && obj.length > 0) {
          obj.forEach(element => {
            element.options[0].innerHTML = `--- ${filteredValue[0].Value} ---`;
          });
        }
      }
    });
  } catch (e) { }
}

Window.DDLSelect = (filteredData, id) => {
  try {
    const obj = document.getElementById(id);
    if (obj) {
      const filteredValue = Window.filterJSON(filteredData, "select");
      if (filteredValue.length > 0 && obj.length > 0) {
        obj[0].innerHTML = `--- ${filteredValue[0].Value} ---`;
      }
    }
  } catch (e) { }
}

Window.NameMenu = (filteredData) => {
  try {
    Object.keys(arrNameMenu).forEach(key => {
      const obj = document.getElementsByName(key);
      if (obj) {
        const filteredValue = Window.filterJSON(filteredData, arrNameMenu[key]);
        if (filteredValue.length > 0 && obj.length > 0) {
          obj.forEach(element => {
            let replaceVal = '';
            switch (key) {
              case 'dashboard': replaceVal = 'Dashboard'; break;
              case 'members': replaceVal = 'Members'; break;
              case 'groups': replaceVal = 'Groups'; break;
              case 'products': replaceVal = 'Products'; break;
              case 'bundles': replaceVal = 'Bundles'; break;
              case 'training_plans': replaceVal = 'Training Plans'; break;
              case 'priviledges': replaceVal = 'Privileges'; break;
              case 'reports_analytics': replaceVal = 'Reports/Analytics'; break;
              case 'reports_analytics_new': replaceVal = 'Reports/Analytics - NEW!'; break;
              case 'edit_menu': replaceVal = 'Edit'; break;
              case 'logs': replaceVal = 'Logs'; break;
              case 'menu_subgroups': replaceVal = 'Subgroups'; break;
              case 'tags': replaceVal = 'Tags'; break;
              case 'my_account': replaceVal = 'My Account'; break;
              case 'inbox': replaceVal = 'Inbox'; break;
              case 'tutorials': replaceVal = 'Tutorials'; break;
              case 'notifications': replaceVal = 'Notifications'; break;
              case 'reports': replaceVal = 'Reports'; break;
              case 'certificates': replaceVal = 'Certificates'; break;
            }

            if (element.innerHTML.includes("Spanish:")) {
              replaceVal = `Spanish:${replaceVal}`;
            }

            if (element.innerHTML.includes("Editar")) {
              element.innerHTML = element.innerHTML.replace("Editar", filteredValue[0].Value);
            } else {
              element.innerHTML = element.innerHTML.replace(replaceVal, filteredValue[0].Value);
            }
          });
        }
      }
    });
  } catch (e) { }
}

Window.DropDownLanguage = (filteredData, ddl, arr) => {
  try {
    let array = {};
    switch (arr) {
      case 'main': array = arrDDLMemberSummary; break;
      case 'verified': array = arrDDLMemberSummary_verified; break;
      case 'disabled': array = arrDDLMemberSummary_disabled; break;
      case 'privileges': array = arrDDLMemberSummary_privileges; break;
      case 'groups': array = arrDDLMemberSummary_groups; break;
      case 'bundles': array = arrDDLMemberSummary_bundles; break;
      case 'products': array = arrDDLMemberSummary_products; break;
      case 'trainingPlans': array = arrDDLMemberSummary_training_plans; break;
      case 'md_training_plan': array = arrDDLMemberDetail_training_plans; break;
      case 'md_products': array = arrDDLMemberDetail_product; break;
      case 'group_option': array = arrDDLGroups_option; break;
      case 'group_assign': array = arrDDLGroups_assign; break;
      //case 'products_option': array = arrDDLProducts_assign; break;
      case 'reporting_option': array = arrDDLReporting_option; break;
      case 'ddlcharacter': array = arrDDLCharacter; break;
      case 'score': array = arrDDLCompare; break;
      case 'number_of_turns': array = arrDDLCompare; break;
      case 'e_learning_time': array = arrDDLCompare; break;
      case 'simulation_time': array = arrDDLCompare; break;
      case 'start_date': array = arrDDLGreaterThanEqualTo; break;
      case 'finish_date': array = arrDDLLessThanEqualTo; break;
      case 'group_parent': array = arrDDLGroupParent; break;
    }

    let index = 0;
    Object.keys(array).forEach(key => {
      const filteredValue = Window.filterJSON(filteredData, array[key]);
      if (filteredValue.length > 0 && ddl.options.length > 0) {
        ddl.options[index].innerHTML = filteredValue[0].Value;
      }
      index++;
    });
  } catch (e) { }
}

Window.Popup = (filteredData, filteredData2) => {
  try {
    const popDialogs = { "popDialog warningBox": "popDialog warningBox", "popDialog successBox": "popDialog successBox", "popDialog errorBox": "popDialog errorBox" };
    Object.values(popDialogs).forEach(dialogClass => {
      const dialogue = document.getElementsByClassName(dialogClass);
      if (dialogue.length > 0) {
        const divs = dialogue[0].getElementsByTagName("div");
        if (divs.length > 0) {
          const currentMessage = divs[0].innerHTML;
          if (currentMessage) {
            Object.keys(arrPopup).forEach(key => {
              const filteredValue = Window.filterJSON(filteredData, arrPopup[key]);
              const filteredValue2 = Window.filterJSON(filteredData2, arrPopup[key]);
              if (filteredValue.length > 0 && filteredValue2.length > 0 && currentMessage.toLowerCase() === filteredValue[0].Value.toLowerCase()) {
                divs[0].innerHTML = filteredValue2[0].Value;
              }

              const closeFilteredValue = Window.filterJSON(filteredData2, "close");
              if (closeFilteredValue.length > 0) {
                divs[1].getElementsByTagName("button")[0].innerHTML = closeFilteredValue[0].Value;
              }
            });
          }
        }
      }
    });
  } catch (e) { }
}

// Function to read and change text of a specific column
Window.readAndChangeColumnText = (tableID, columnIndex) => {
  // Select all rows in the tbod  
  const rows = document.querySelectorAll(tableID + ' table > tbody > tr');

  rows.forEach(row => {
    // Select the td of the specific column index
    const td = row.children[columnIndex];

    if (td) {
      // Select the inner div inside td
      const innerDiv = td.querySelector('div > div');

      if (innerDiv) {
        // Log the current text
        //console.log(innerDiv.textContent);        
        const translatedText = Window.getTranslatedText(innerDiv.textContent)

        // Change the text content to the new text
        innerDiv.textContent = translatedText;
      }
    }
  });
}



export { arrIDSingle };
